import RootStore from "../rootStore";

const deleteLastPointHandler = (store: RootStore) => {
  if (
    store.labelerSegmentationStore.isReadOnly ||
    store.labelerSegmentationUiStore.imageLoadError
  ) {
    return;
  }

    const {
        labelerSegmentationUiStore: {
            selectMode,
            findPolygonNotDone,
            updatePolygonPoints
        }
    } = store

    if (selectMode) return;

    const polyNotDone = findPolygonNotDone();
    if (polyNotDone) {
        const allButLastPoint = polyNotDone.points.slice(0, -1);
        updatePolygonPoints(polyNotDone, allButLastPoint);
    }
}

export default deleteLastPointHandler